export enum QueryDataType {
  /* 获取所有的数据 */
  All = 'all',
  /* 只需要明细数据 */
  DetailOnly = 'detailOnly',
}
